<div class="rtl relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
    <div class="rounded-t border-b-2 mb-0 px-6 py-6">
      <div class="p-4">
        <h5 class="text-primary text-2xl font-bold mb-4">  کیف پول من </h5>
        <h6 class="text-base text-gray-600"> موجودی شما با کسر پرداخت ویزیت ها: </h6>
        <h6 class="text-base text-gray-600">  999999999 تومان می باشد. </h6>
      </div>
    </div>

    <div class="flex flex-wrap pt-6">
        
        <h5 class="text-blueGray-700 text-base font-bold p-4">  تراکنش مالی: </h5>
        <!-- <div class="w-full lg:w-4/12 px-4">
            <div class="relative w-full mb-3"><label htmlfor="grid-password"
                    class="block uppercase text-blueGray-600 text-xs font-bold mb-2"> وضعیت </label><input type="email"
                    class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
            </div>
        </div>
        <div class="w-full lg:w-4/12 px-4">
            <div class="relative w-full mb-3"><label htmlfor="grid-password"
                    class="block uppercase text-blueGray-600 text-xs font-bold mb-2"> تاریخ </label><input type="text"
                    class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
            </div>
        </div> -->
    </div>

    <div class="flex-auto p-4">
        <div class="relative w-full overflow-x-auto">
            <table class="w-full bg-transparent border-collapse">
              <thead class="bg-primary text-white">
                <tr>
                  <th
                    class="px-6 align-middle border border-solid py-3 text-base uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold" >
                    تاریخ
                  </th>
                  <th
                    class="px-6 align-middle border border-solid py-3 text-base uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold" >
                    زمان
                  </th>
                  <th
                    class="px-6 align-middle border border-solid py-3 text-base uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold"  >
                    نام پزشک
                  </th>
                  <th
                    class="px-6 align-middle border border-solid py-3 text-base uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold" >
                    نوع تخصص
                  </th>
                  <th
                    class="px-6 align-middle border border-solid py-3 text-base uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold" >
                    مبلغ 
                  </th>
                  <th
                    class="px-6 align-middle border border-solid py-3 text-base uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold" >
                    شناسه پرداخت
                  </th>
                  <th
                    class="px-6 align-middle border border-solid py-3 text-base uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold" >
                    وضعیت
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-b">
                  <th
                    class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
                  >
                      تصویری
                  </th>
                  <td
                    class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
                  >
                    $2,500 USD
                  </td>
                  <td
                    class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
                  >
                    <i class="fas fa-circle text-orange-500 mr-2"></i> pending
                  </td>
                  <td
                    class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
                  >
                    علیرضا اکبری
                  </td>
                  <td
                    class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
                  >
                    $2,500 USD
                  </td>
                  <td
                    class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
                  >
                    <i class="fas fa-circle text-orange-500 mr-2"></i> pending
                  </td>
                  <td
                    class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
                  >
                    <div class="flex items-center">
                      <span class="mr-2">60%</span>
                      <div class="relative w-full">
                        <div
                          class="overflow-hidden h-2 text-xs flex rounded bg-red-200"
                        >
                          <div
                            style="width: 60%"
                            class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-red-500"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr class="border-b">
                  <th
                    class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
                  >
                      تلفنی
                  </th>
                  <td
                    class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
                  >
                    $2,500 USD
                  </td>
                  <td
                    class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
                  >
                    <i class="fas fa-circle text-orange-500 mr-2"></i> pending
                  </td>
                  <td
                    class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
                  >
                    شهرام بابایی
                  </td>
                  <td
                    class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
                  >
                    $2,500 USD
                  </td>
                  <td
                    class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
                  >
                    <i class="fas fa-circle text-orange-500 mr-2"></i> pending
                  </td>
                  <td
                    class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
                  >
                    <div class="flex items-center">
                      <span class="mr-2">60%</span>
                      <div class="relative w-full">
                        <div
                          class="overflow-hidden h-2 text-xs flex rounded bg-red-200"
                        >
                          <div
                            style="width: 60%"
                            class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-red-500"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                
              </tbody>
            </table>
          </div>
    </div>
</div>
    